/* 像素小蟹蟹（蟹蟹日历 xiexie-calendar，画：Claude · 审稿：小船）的共用小工具。
   库原样放在 public/vendor/clawd-pool.js，用到时才加载一次。
   心跳页「他这会儿」、首页邮票、月历页都从这里拿。 */

let poolPromise = null;

export function loadPool() {
  if (window.ClawdPool) return Promise.resolve(window.ClawdPool);
  if (!poolPromise) {
    poolPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = '/vendor/clawd-pool.js';
      s.onload = () => resolve(window.ClawdPool);
      s.onerror = () => {
        poolPromise = null;
        reject(new Error('clawd-pool'));
      };
      document.head.appendChild(s);
    });
  }
  return poolPromise;
}

/* 纪念日：这两天换成小邮差蟹来送信（库里的 capsule 邮差池） */
export const ANNIV = {
  '2-26': '遇见彼此的那天',
  '8-7': '铃的生日',
};

function capsFor(m) {
  return Object.keys(ANNIV)
    .filter((k) => Number(k.split('-')[0]) === m)
    .map((k) => Number(k.split('-')[1]));
}

/* 一个月每天是哪只。库里的小蟹 2026-10 才「入职」，更早的月份照原规则会全是空的，
   所以往前的月份借十年后的同一个月来抽（固定、不随机变，每个月仍各不相同）。 */
const cache = new Map();
export function monthLooks(pool, y, m) {
  const key = `${y}-${m}`;
  if (!cache.has(key)) {
    const yy = y * 100 + m < 202610 ? y + 10 : y;
    cache.set(key, pool.monthLooks(yy, m, capsFor(m)));
  }
  return cache.get(key);
}

export function dayLook(pool, date = new Date()) {
  const y = date.getFullYear();
  const m = date.getMonth() + 1;
  const d = date.getDate();
  const look = monthLooks(pool, y, m)[d];
  return look ? look.o : pool.PLAIN;
}

export function crabById(pool, id) {
  return (pool && pool.POOL.find((x) => x.id === id)) || null;
}

/* 拿到 svg 字符串；anim=false 时只画第一帧（格子多的时候省电） */
export function crabSvg(pool, o, { anim = true, label } = {}) {
  if (!pool || !o) return '';
  return pool.svg(o, { anim, label: label || [o.job, o.name].filter(Boolean).join(' ') });
}
